module.exports = __webpack_public_path__ + "static/media/collaboration-among-departments.82afccb6.mp4";